export default __webpack_public_path__ + "static/media/hadoop.7f907883.svg";